module.exports = __webpack_public_path__ + "static/media/transactions.b82b7cb6.svg";